/*
 * @Description: 首页Banner位骨架
 * @Author: 蔺晨
 * @Date: 2020-12-11
 */
import React, { Component } from 'react';
import Shape from './Shape';
import { Flex } from 'antd-mobile';

// @withRouter
export default class BannerFrame extends Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <Shape
        id="home-banner"
        type="square"
        w="100%"
        h="calc(100vw * 88 / 75)"
        style={{ marginBottom: '30px' }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/pubBiz/FrameWork/BannerFrame.js